export default (json: IObject = {}) => Object.keys(json).reduce((memo: any, key) => {
  memo[json[key]] = key;
  return memo;
}, {});



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--1-0!./src/utils/jsonToMap.ts